import React from 'react';
import { Text, TextProps } from '@nimbus-ds/components';
import { Country } from 'App/i18n/enums';
import { useCountry } from 'commons/hooks';

type TextByCountryProps = {
  [key in Country]?: string;
} & Omit<TextProps, 'children'>;

const TextByCountry: React.FC<TextByCountryProps> = (props) => {
  const { storeCountry } = useCountry();

  if (!props[storeCountry]) return <></>;

  return <Text {...props}>{props[storeCountry]}</Text>;
};

export default TextByCountry;
